export default __webpack_public_path__ + "static/packed-39a12e01dca73cfbe1282fb61654b6d8.png";